export const TIMESHEET_THIS_WEEKS_WORK_PAGE_SIZE = 50;
